import { render, staticRenderFns } from "./BulkImportDialog.vue?vue&type=template&id=7136907e&"
import script from "./BulkImportDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BulkImportDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports